const state = {
  page: {},
  pages: {
    TestPage: {
      name: "TestPage",
      description: {
        en: "Test",
        es: "Test",
      },
      displayPageTitle: true,
      value: 0,
      displayLangaugeSelection: true,
    },
    KioskLanding: {
      name: "KioskLanding",
      description: {
        en: "",
        es: "",
      },
      displayPageTitle: false,
      value: 1,
      displayLangaugeSelection: false,
    },
    TokenLogin: {
      name: "TokenLogin",
      description: {
        en: "",
        es: "",
      },
      displayPageTitle: false,
      value: 2,
      displayLangaugeSelection: false,
    },
    DateOfBirthLogin: {
      name: "DateOfBithLogin",
      description: {
        en: "",
        es: "",
      },
      displayPageTitle: false,
      value: 3,
      displayLangaugeSelection: false,
    },
    TestSelection: {
      name: "TestSelection",
      description: {
        en: "Test Selection",
        es: "Selección de pruebas",
      },
      displayPageTitle: true,
      value: 4,
      displayLangaugeSelection: true,
    },
    TestInstructions: {
      name: "TestInstructions",
      description: {
        en: "Test Instructions",
        es: "Instrucciones de prueba",
      },
      displayPageTitle: true,
      value: 5,
      displayLangaugeSelection: true,
    },
    PracticeTest: {
      name: "PracticeTest",
      description: {
        en: "Practice Test",
        es: "Examen de práctica",
      },
      displayPageTitle: true,
      value: 6,
      displayLangaugeSelection: true,
    },
    Test: {
      name: "Test",
      description: {
        en: "Test",
        es: "Test",
      },
      displayPageTitle: true,
      value: 7,
      displayLangaugeSelection: true,
    },
    TestScoreCard: {
      name: "TestScoreCard",
      description: {
        en: "Test Results Summary",
        es: "Resumen de los resultados de la prueba",
      },
      displayPageTitle: true,
      value: 8,
      displayLangaugeSelection: true,
    },
    TestQuestionSummary: {
      name: "TestQuestionSummary",
      description: {
        en: "Test Summary",
        es: "Test Summary",
      },
      displayPageTitle: true,
      value: 9,
      displayLangaugeSelection: true,
    },
    Offline: {
      name: "Offine",
      description: {
        en: "Offline",
        es: "Offline",
      },
      displayPageTitle: false,
      value: 99,
      displayLangaugeSelection: false,
    },
  },
};

const getters = {
  page(state) {
    return state.page;
  },

  pages(state) {
    return state.pages;
  },
};

const mutations = {
  SET_PAGE(state, pageName) {
    state.page = state.pages[pageName];
  },
  SET_TEST_DESCRIPTION(state, testName) {
    state.pages.Test.description.en = testName;
    state.pages.Test.description.es = testName;
  },
};

const actions = {
  SetPage({ commit }, pageName) {
    commit("SET_PAGE", pageName);
    //state.page = this.$store.pages[pageName];
  },
  SetTestDescription({ commit }, testName) {
    commit("SET_TEST_DESCRIPTION", testName);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
